import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
@Component({
  selector: 'mitel-coverletter',
  templateUrl: './coverletter.component.pug',
  styleUrls: ['./coverletter.component.styl']
})
export class CoverletterMitelComponent implements OnInit {

	public constructor(private titleService: Title) { }
  
	title: string;
	subtitle: string;
	tirtitle: string;
	company: string;

	ngOnInit() {
		this.title='Mitel';
		this.subtitle='Human Resources';
		this.titleService.setTitle("Liam Hogan's Cover Letter");
		this.tirtitle='';
		this.company='Mitel'; 
	}

}
